import { Box, Button, Divider, Sheet, Typography } from "@mui/joy";
import { DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { formOpenSelector, setFormOpen } from "../../reducers/rhapsody";
import DialogClose from "../dialogClose/dialogClose";
import { useCurrentUser } from "../../redux/user/userHook";
import {
  DialogHeader,
  FieldLabel,
  GroupCaption,
  dialogPaperSx,
  groupSheetSx,
  pillButtonSx,
  tileColors,
} from "../formKit/formKit";

/**
 *
 * @returns {ReactElement} DeleteMyAccount page
 */
export function DeleteMyAccount() {
  const open = useSelector(formOpenSelector("deleteMyAccount"));
  const dispatch = useDispatch();
  const { me: data } = useCurrentUser();

  const onClose = () => {
    dispatch(setFormOpen({ formID: "deleteMyAccount", isOpen: false }));
  };

  return (
    <DialogClose
      open={open}
      onClose={onClose}
      PaperProps={{ sx: dialogPaperSx }}
    >
      <DialogTitle>
        <DialogHeader
          title="We will miss you!"
          subtitle="We'll make sure to delete your account within 2 business days."
        />
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          width: 440,
          maxWidth: "100%",
        }}
      >
        <GroupCaption>What happens next</GroupCaption>
        <Sheet variant="soft" sx={groupSheetSx}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, p: 1.5 }}>
            <FieldLabel icon="fa-solid fa-trash-can" color={tileColors.red} />
            <Typography level="body2">
              We will delete your Rhapsody account and all its related data.
            </Typography>
          </Box>
          <Divider />
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, p: 1.5 }}>
            <FieldLabel
              icon="fa-solid fa-triangle-exclamation"
              color={tileColors.red}
            />
            <Typography level="body2">
              We won't be able to recover anything.
            </Typography>
          </Box>
        </Sheet>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="plain"
          color="neutral"
          sx={pillButtonSx}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            onClose();
            window.open(
              `mailto:contact@rhapsody.la?subject=Delete my account&body=Please delete the following account: userUUID=${data?.uuid}`,
              "_blank"
            );
          }}
          variant="solid"
          color="danger"
          sx={pillButtonSx}
        >
          Delete my Account
        </Button>
      </DialogActions>
    </DialogClose>
  );
}
